import { Button, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

interface AvailabilityColumnProps {
  availability: string;
  mobile?: boolean;
}

export default function AvailabilityColumn({ availability, mobile }: AvailabilityColumnProps) {
  const theme = useMantineTheme();
  const isMobile = mobile;

  const num = parseFloat(availability.replace(',', '.'));

  let color: 'red' | 'yellow' | 'green' = 'green';
  let label: string;

  if (isNaN(num) || num <= 0) {
    color = 'red';
    label = isMobile ? 'Non disponibile' : 'Non disponibile';
  } else if (num <= 4) {
    color = 'yellow';
    label = isMobile ? `Disponibilità: ${num}` : `Disponibilità Scarsa: ${num}`;
  } else {
    color = 'green';
    label = isMobile ? `Disponibilità: ${num}` : `Disponibilità: ${num}`;
  }

  return (
    <Button
      radius="lg"
      color={color}
      size="xs"
      variant="filled"
      style={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        lineHeight: '14px',
      }}
    >
      {label}
    </Button>
  );
}
